var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 56,
    viewBox: "0 0 35 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1368",
    "data-name": "Groupe 1368",
    transform: "translate(-1088.848 -181.47)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1362",
    "data-name": "Groupe 1362",
    transform: "translate(1088.988 181.469)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Ligne_284",
    "data-name": "Ligne 284",
    x2: 19.18,
    transform: "translate(7.783 43.141)",
    fill: "none",
    stroke: "#ba9757",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_287",
    "data-name": "Ligne 287",
    y2: 28.53,
    transform: "translate(17.372 10.654)",
    fill: "none",
    stroke: "#ba9757",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_285",
    "data-name": "Ligne 285",
    x2: 8.171,
    y2: 8.074,
    transform: "translate(9.185 30.653)",
    fill: "none",
    stroke: "#ba9757",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_286",
    "data-name": "Ligne 286",
    x2: 8.171,
    y2: 8.074,
    transform: "translate(17.389 38.727) rotate(-90)",
    fill: "none",
    stroke: "#ba9757",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_186",
    "data-name": "Rectangle 186",
    transform: "translate(-0.14 0.001)",
    fill: "none",
    stroke: "#c0964b",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 56,
    rx: 17.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 34,
    height: 55,
    rx: 17,
    fill: "none"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.3b8b0b7c7d3fe52eabf2f1a309ec4a82.svg";
export { ForwardRef as ReactComponent };